module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.timelogger.visible) ? _c('div', {
    attrs: {
      "id": "timelogger"
    }
  }, [_c('div', {
    staticClass: "dimmer",
    on: {
      "click": function($event) {
        return _vm.closeTimelogger()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup"
  }, [
    [_c('table', {
      staticClass: "timelogger-entries"
    }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.globals.timelogger.addList), function(entry, i) {
      return _c('tr', {
        key: i
      }, [_c('td', [_c('div', {
        staticClass: "label"
      }, [_vm._v("Dato")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (entry.date),
          expression: "entry.date"
        }],
        staticClass: "unstyled",
        attrs: {
          "type": "date"
        },
        domProps: {
          "value": (entry.date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(entry, "date", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "label"
      }, [_vm._v("Timer")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.number",
          value: (entry.hours),
          expression: "entry.hours",
          modifiers: {
            "number": true
          }
        }],
        attrs: {
          "type": "number",
          "step": ".25",
          "min": "0.25",
          "max": "24",
          "placeholder": "Timetal"
        },
        domProps: {
          "value": (entry.hours)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(entry, "hours", _vm._n($event.target.value))
          },
          "blur": function($event) {
            return _vm.$forceUpdate()
          }
        }
      })]), _vm._v(" "), _c('td', [(false) ? _c('div', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (entry.project_key),
          expression: "entry.project_key"
        }],
        attrs: {
          "name": "",
          "id": ""
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(entry, "project_key", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "undefined"
        }
      }, [_vm._v("Vælg...")]), _vm._v(" "), _vm._l((_vm.projects), function(project, i) {
        return _c('option', {
          domProps: {
            "value": project['.key']
          }
        }, [_vm._v("\n                    " + _vm._s(project.name) + " - " + _vm._s(_vm.getClient(project['.key']).name) + "\n                  ")])
      })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "label"
      }, [_vm._v("Opgave")]), _vm._v(" "), _c('multiselect', {
        attrs: {
          "options": _vm.projectSelectOptions,
          "placeholder": "Vælg...",
          "label": "label",
          "track-by": "value",
          "select-label": "",
          "selected-label": "",
          "deselect-label": "",
          "value": _vm.multiSelectGetOption(_vm.projectSelectOptions, 'value', entry.project_key),
          "reset-after": false
        },
        on: {
          "select": function($event) {
            return _vm.multiSelectOnSelect('project', $event, entry)
          }
        }
      })], 1), _vm._v(" "), (false) ? _c('td', [(_vm.getClient(entry.project_key)) ? [_vm._v("\n                " + _vm._s(_vm.getClient(entry.project_key).name) + "\n              ")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (false) ? _c('td', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (entry.task_key),
          expression: "entry.task_key"
        }],
        attrs: {
          "name": "",
          "id": ""
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(entry, "task_key", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.tasks), function(task, i) {
        return (task.project_key == entry.project_key) ? _c('option', {
          domProps: {
            "value": task['.key']
          }
        }, [_vm._v(_vm._s(task.title))]) : _vm._e()
      }), 0)]) : _vm._e(), _vm._v(" "), _c('td', [(false) ? _c('div', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (entry.worktype),
          expression: "entry.worktype"
        }],
        attrs: {
          "name": "",
          "id": ""
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(entry, "worktype", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "undefined"
        }
      }, [_vm._v("Vælg...")]), _vm._v(" "), _vm._l((_vm.worktypes), function(worktype, i) {
        return _c('option', {
          domProps: {
            "value": worktype.value
          }
        }, [_vm._v(_vm._s(worktype.title))])
      })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "label"
      }, [_vm._v("Arbejdstype")]), _vm._v(" "), _c('multiselect', {
        attrs: {
          "options": _vm.worktypes,
          "placeholder": "Vælg...",
          "label": "title",
          "select-label": "",
          "selected-label": "",
          "deselect-label": "",
          "track-by": "value",
          "value": _vm.multiSelectGetOption(_vm.worktypes, 'value', entry.worktype),
          "reset-after": false
        },
        on: {
          "select": function($event) {
            return _vm.multiSelectOnSelect('worktype', $event, entry)
          }
        }
      })], 1), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "label"
      }, [_vm._v("Note")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (entry.title),
          expression: "entry.title"
        }],
        attrs: {
          "type": "text",
          "_placeholder": ""
        },
        domProps: {
          "value": (entry.title)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(entry, "title", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "checkbox"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (entry.billable),
          expression: "entry.billable"
        }],
        attrs: {
          "type": "checkbox",
          "id": 'kj12b3kj+i'
        },
        domProps: {
          "checked": Array.isArray(entry.billable) ? _vm._i(entry.billable, null) > -1 : (entry.billable)
        },
        on: {
          "change": function($event) {
            var $$a = entry.billable,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(entry, "billable", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(entry, "billable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(entry, "billable", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": 'kj12b3kj' + i
        }
      })])]), _vm._v(" "), _c('td', [(!_vm.lineIsReady(i)) ? void 0 : _vm._e(), _vm._v(" "), (_vm.lineIsReady(i)) ? _c('span', [_c('svgicon', {
        attrs: {
          "icon": "ionicons/checkmark"
        }
      })], 1) : _vm._e()], 2), _vm._v(" "), _c('td', [_c('btn', {
        attrs: {
          "color": "secondary"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.dupeLineBelow(i)
          }
        }
      }, [_c('svgicon', {
        attrs: {
          "icon": "ionicons/ios-plus-empty"
        }
      })], 1)], 1), _vm._v(" "), _c('td', [_c('btn', {
        attrs: {
          "color": "secondary"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.stripEntry(i)
          }
        }
      }, [_c('svgicon', {
        attrs: {
          "icon": "linearicons/cross"
        }
      })], 1)], 1)])
    }), 0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "grid"
    }, [_c('div', {
      staticClass: "col m50"
    }, [_c('btn', {
      attrs: {
        "color": "secondary",
        "id": "addrowbtn"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.addEmptyRow()
        }
      }
    }, [_vm._v("\n          Tilføj linje\n        ")]), _vm._v("\n         \n        "), (false) ? _c('btn', {
      attrs: {
        "color": "primary",
        "id": "fetchfromlatestprojects"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.fetchLastProjects()
        }
      }
    }, [_vm._v("Hent fra nyeste projekter")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col m50 align-r"
    }, [_c('btn', {
      attrs: {
        "color": "primary",
        "disabled": !_vm.somethingToSubmit()
      },
      nativeOn: {
        "click": function($event) {
          return _vm.createNewTimelogs()
        }
      }
    }, [_vm._v("Log " + _vm._s(_vm.getAddListTotalHoursCount()) + " timers arbejde")])], 1)])], _vm._v(" "), _c('div', {
      staticClass: "killer",
      on: {
        "click": function($event) {
          return _vm.closeTimelogger()
        }
      }
    }, [_vm._v("X")])
  ], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Timer")]), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', [_vm._v("Arbejdstype")]), _vm._v(" "), _c('th', [_vm._v("Note")]), _vm._v(" "), _c('th', [_vm._v("Fakturérbar")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-194c3aef","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Timelogger.vue
// module id = 584
// module chunks = 1